import { render, staticRenderFns } from "./informationPop.vue?vue&type=template&id=23a4255c&scoped=true&"
import script from "./informationPop.vue?vue&type=script&lang=js&"
export * from "./informationPop.vue?vue&type=script&lang=js&"
import style0 from "./informationPop.vue?vue&type=style&index=0&id=23a4255c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a4255c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23a4255c')) {
      api.createRecord('23a4255c', component.options)
    } else {
      api.reload('23a4255c', component.options)
    }
    module.hot.accept("./informationPop.vue?vue&type=template&id=23a4255c&scoped=true&", function () {
      api.rerender('23a4255c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/cardholder-change/modules/informationPop.vue"
export default component.exports